import { useEffect, useRef, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import { message, Spin } from 'antd';
import { getDataRequest } from '../../api/serviceMethods';
import { PRODUCTS_KNOWLEDGE_URL } from '../../api/URLs';
import { useTranslation } from 'react-i18next';
import DragViewMobileComponentView from '../newsManagemet/DragViewMobileComponentView';

const ProductKnowledgeMobileViewModal = (props) => {
  const { t } = useTranslation();
  const { id: propId, productKnowledgeId, show, setShow } = props;
  const id = productKnowledgeId || propId;
  const [loading, setLoading] = useState(false);
  const messageModalRef = useRef('');
  const [datalocalize, setDatalocalize] = useState(null);

  const getDetailById = async () => {
    try {
      setLoading(true);
      await getDataRequest(`${PRODUCTS_KNOWLEDGE_URL}/${id}`)
        .then((res) => {
          if (res.status === 200) {
            const detailData = res.data?.data && typeof res.data.data === 'object' ? res.data.data : res.data;
            setDatalocalize(detailData);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      message.error('Server Error!');
    }
  };

  useEffect(() => {
    if (id) {
      getDetailById();
    }
  }, [id]);

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setDatalocalize(null);
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="custom-header">
          <Modal.Title className="text-center w-100">{t('Product Knowledge')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Spin spinning={loading}>
            <Row className="section-content">
              <Col>
                <div className="mt-3 w-100 mb-3">
                  <DragViewMobileComponentView
                    datalocalize={datalocalize}
                    data={datalocalize}
                    setDatalocalize={setDatalocalize}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </div>
              </Col>
            </Row>
          </Spin>
        </Modal.Body>
      </Modal>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </>
  );
};

export default ProductKnowledgeMobileViewModal;
